import { Form, Select, Tooltip } from "antd";
import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import classes from "../../../components/ReportList/styles.module.css";

export const QMSConfigFilter = (allindexes, config) => {
  if (Array.isArray(config.searchable_indexes)) {
    config.searchable_indexes = [
      ...config.searchable_indexes.filter((el) => allindexes.includes(el)),
    ];
  }
  if (Array.isArray(config.project_indexes_in_session_table)) {
    config.project_indexes_in_session_table = [
      ...config.project_indexes_in_session_table.filter((el) =>
        allindexes.includes(el)
      ),
    ];
  }
};

export const getQMSDefaultConfigs = {
  searchable_indexes: [],
  project_indexes_in_session_table: [],
  submission_method: [],
  unique_filter_index: [],
};

export const validateQMS = (data, validate) => {
  validate.qms_submission_method =
    !Array.isArray(data.submission_method) ||
    data.submission_method.length === 0; //mandatory indexes
  validate.qms_searchable_indexes =
    !Array.isArray(data.searchable_indexes) ||
    data.searchable_indexes.length === 0; //mandatory indexes
  validate.qms_project_indexes_in_session_table =
    !Array.isArray(data.project_indexes_in_session_table) ||
    data.project_indexes_in_session_table.length === 0;
  validate.qms_unique_filter_index =
    !Array.isArray(data.unique_filter_index) ||
    data.unique_filter_index.length !== 1; //mandatory indexes
};

const tooltipStyle = {
  paddingLeft: 8,
  color: "red",
};

const selectElmStyles = { maxWidth: 450 };

function QMS(props) {
  return (
    <div className="app_config_checkbox_class2">
      <Form.Item {...props.formItemLayout} label="Searchable Indexes">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          className={props.validate.qms_searchable_indexes ? classes.error : ""}
          placeholder="Searchable Indexes"
          value={props.config.searchable_indexes}
          onChange={(e) =>
            props.updateValue(e, props.app_id, "searchable_indexes")
          }
        >
          {props.indexes.map((el) => (
            <Select.Option value={el._id} key={el._id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        {...props.formItemLayout}
        label="Project Indexes in Session Table"
      >
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          className={
            props.validate.qms_project_indexes_in_session_table
              ? classes.error
              : ""
          }
          placeholder="Project Indexes in Session Table"
          value={props.config.project_indexes_in_session_table}
          onChange={(e) =>
            props.updateValue(
              e,
              props.app_id,
              "project_indexes_in_session_table"
            )
          }
        >
          {props.indexes.map((el) => (
            <Select.Option value={el._id} key={el._id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item {...props.formItemLayout} label="Submission Methods">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          className={props.validate.qms_submission_method ? classes.error : ""}
          placeholder="Submission Methods"
          value={props.config.submission_method}
          onChange={(e) =>
            props.updateValue(e, props.app_id, "submission_method")
          }
        >
          <Select.Option value="ULP">ULP</Select.Option>
          <Select.Option value="Email">Email</Select.Option>
          <Select.Option value="MDO Printer">MDO Printer</Select.Option>
          <Select.Option value="SS3U">SS3U</Select.Option>
          <Select.Option value="Virtual Printer">Virtual Printer</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item {...props.formItemLayout} label="Unique Filter Index">
        <Select
          style={selectElmStyles}
          showSearch={true}
          placeholder="Unique Filter Index"
          value={props.config.unique_filter_index}
          mode="multiple"
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          className={
            props.validate.qms_unique_filter_index ? classes.error : ""
          }
          onChange={(e) =>
            props.updateValue(e, props.app_id, "unique_filter_index")
          }
        >
          {props.indexes.map((el) => (
            <Select.Option value={el._id} key={el._id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
        <Tooltip
          placement="topLeft"
          title="please select one unique index"
          arrowPointAtCenter
        >
          <ExclamationCircleOutlined style={tooltipStyle} />
        </Tooltip>
      </Form.Item>
    </div>
  );
}

export default React.memo(QMS);
